export default __webpack_public_path__ + "static/sl1AejFf-341458252a0867833294766399f0c39f.jpeg";